import { render, staticRenderFns } from "./ManagementPage.vue?vue&type=template&id=239e3cb5"
import script from "./ManagementPage.vue?vue&type=script&lang=js"
export * from "./ManagementPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports